export function createReaderSettingsBridge({
  getReaderSettingsModuleApi,
  invokeReaderSettings
}) {
  function changeFontSize(delta) {
    const api = getReaderSettingsModuleApi();
    if (api?.changeFontSize) {
      api.changeFontSize(delta);
      return;
    }
    invokeReaderSettings('changeFontSize', delta);
  }

  function changeLineHeight(value) {
    const api = getReaderSettingsModuleApi();
    if (api?.changeLineHeight) {
      api.changeLineHeight(value);
      return;
    }
    invokeReaderSettings('changeLineHeight', value);
  }

  function changeFontFamily(font) {
    const api = getReaderSettingsModuleApi();
    if (api?.changeFontFamily) {
      api.changeFontFamily(font);
      return;
    }
    invokeReaderSettings('changeFontFamily', font);
  }

  function changeTheme(theme) {
    const api = getReaderSettingsModuleApi();
    if (api?.changeTheme) {
      api.changeTheme(theme);
      return;
    }
    invokeReaderSettings('changeTheme', theme);
  }

  function applyReaderSettings() {
    const api = getReaderSettingsModuleApi();
    if (api?.applyReaderSettings) {
      api.applyReaderSettings();
      return;
    }
    invokeReaderSettings('applyReaderSettings');
  }

  function loadReaderSettings() {
    const api = getReaderSettingsModuleApi();
    if (api?.loadReaderSettings) {
      api.loadReaderSettings();
      return;
    }
    invokeReaderSettings('loadReaderSettings');
  }

  return {
    changeFontSize,
    changeLineHeight,
    changeFontFamily,
    changeTheme,
    applyReaderSettings,
    loadReaderSettings
  };
}
